export const CREATING_POLL = 'Creating Poll';
export const UPDATING_POLL = 'Updating Poll';
export const RETRIEVING_POLL_RESULTS = 'Retrieving Poll Results';
